import { i18n } from "../../i18n/i18n";

import React, { useState } from 'react';
import './popup.css';
import Button from '../../components/Button'
import PopupHeadingRow from '../../components/PopupHeadingRow'

interface ImagePopupProps {
  isOpen: boolean;
  imageLink: string
  handleCloseClick: () => void
}

const ImagePopup: React.FC<ImagePopupProps> = ({isOpen, imageLink, handleCloseClick}) => {
  return (
    <div>
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup" onClick={(e) => e.stopPropagation()}>    
          <br />
          <br /><br />
            <img src={imageLink} style={{ maxWidth:500, maxHeight:500}}/>
            <PopupHeadingRow
              heading=""
              doc='upc-error-block-warning'>
                <Button
                text={i18n("Close")}
                onClick={handleCloseClick} />
            </PopupHeadingRow>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImagePopup;